// extracted by mini-css-extract-plugin
export default {"stopwatch":"Timer_stopwatch__zq-vw","numbers":"Timer_numbers__Z3Xio","buttons":"Timer_buttons__awzsV"};